import React from 'react';
import withIcon from '../utilities/withIcon';

const IconChevronRight = () => {
  return (
    <g>
      <path d="M4.231 13.708a.75.75 0 0 0 .956 1.151l.085-.07 6.499-6.25a.75.75 0 0 0 .076-.995l-.076-.085L5.272 1.21a.751.751 0 0 0-1.115.999l.074.082L10.167 8 4.23 13.708z" />
    </g>
  );
};

export default withIcon(IconChevronRight);
